import { PieceAction } from '@apiContract';
import { Label } from '@components/Label';
import { PaletteColorKey } from '@minimalsTheme/core/palette';

import { mailpieceActions } from '../index';

const mailpieceActionLabelColors: { [key in PieceAction]?: string } = {
  [PieceAction.RequestRecycle]: 'error',
  [PieceAction.RequestShred]: 'error',
  [PieceAction.RequestOpenAndScan]: 'success',
  [PieceAction.RequestPickUp]: 'warning',
  [PieceAction.RequestForward]: 'info',
  [PieceAction.RequestDelivery]: 'purple',
  [PieceAction.RequestReturnToSender]: 'brown',
};

interface MailpieceActionLabelProps {
  action: PieceAction;
}

export const MailpieceActionLabel = ({ action }: MailpieceActionLabelProps) => {
  const actionData = mailpieceActions[action];

  if (!actionData) return <Label color="error">Unknown Action</Label>;

  const { title, Icon } = actionData;

  return (
    <Label color={mailpieceActionLabelColors[action] as PaletteColorKey}>
      <Icon sx={{ width: 16, height: 16, mr: 1 }} />
      {typeof title === 'function' ? title() : title}
    </Label>
  );
};
